import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Preloader({ onComplete }) {
  const [phase, setPhase] = useState('draw'); // draw | hold | exit
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('hold'), 1800);
    const t2 = setTimeout(() => setPhase('exit'), 2600);
    const t3 = setTimeout(() => {
      setDone(true);
      onComplete?.();
    }, 3400);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="preloader"
          data-testid="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          {/* Top curtain */}
          <motion.div
            className="preloader-curtain preloader-curtain-top"
            animate={phase === 'exit' ? { y: '-100%' } : { y: 0 }}
            transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
          />
          {/* Bottom curtain */}
          <motion.div
            className="preloader-curtain preloader-curtain-bottom"
            animate={phase === 'exit' ? { y: '100%' } : { y: 0 }}
            transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
          />

          {/* Center: SVG monogram with stroke draw */}
          <div className="preloader-logo">
            <svg
              width="120"
              height="120"
              viewBox="0 0 120 120"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <motion.path
                d="M58 16C34.8 16 16 34.8 16 58C16 81.2 34.8 100 58 100C68.5 100 78 96 85 89.5"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 1.5, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
              />
              <motion.path
                d="M52 32L75 92L98 32"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                initial={{ pathLength: 0, opacity: 0 }}
                animate={{ pathLength: 1, opacity: 1 }}
                transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1], delay: 0.5 }}
              />
            </svg>
            <motion.span
              className="preloader-text"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2, duration: 0.6 }}
            >
              Civic Ventures
            </motion.span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
